import React from 'react';
import { Fieldset, FormNumber, FormRadio } from '~/components/FormControl';
import { Form } from 'react-bootstrap';
import { formLabel } from '~/utils/helpers';

function Others() {
    return (
        <Fieldset
            className={'px-2'}
            fieldsetStyle={{ flexGrow: 1 }}
        >
            <Fieldset.Legend>{formLabel('Others')}</Fieldset.Legend>
            <Form.Row>
                <FormNumber
                    name="dailyHpm"
                    sm={6}
                />
                <FormRadio
                    name="isImmortal"
                    sm={3}
                />
                <FormRadio
                    name="isTireless"
                    sm={3}
                />
            </Form.Row>
        </Fieldset>
    );
}

export default Others;
